import { createContext, useContext } from 'react';
import { IAlert } from 'components/atoms/Alert';

export interface IAlertContext {
  setAlert: (type: string, payload: IAlert) => void;
  clearAlert: (type: string) => void;
  samePageAlert: null | IAlert;
  nextPageAlert: null | IAlert;
  authAlert: null | IAlert;
  userAlert: null | IAlert;
  trustedDeviceAlert: null | IAlert;
}

export const AlertContext = createContext<IAlertContext>({} as IAlertContext);

export const useAlert = (): IAlertContext => useContext(AlertContext);
